// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2UEWy","author":"Table_author__2J5bR","authorImage":"Table_authorImage__20qiq","unreadRow":"Table_unreadRow__3NI6t"};